import React from 'react'
import PropTypes from 'prop-types'

// Material-UI
//   npm install --save material-ui
import * as mui from 'material-ui'

// 自作ユーティリティ・ツール
import * as GridUtils from '../GridUtils'
import * as def from '../define'

/**
 * 処理選択
 */
export default class ModeSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      info: Object.assign({}, this.props.info),
    }
  }

  onCreateTenantClick() {
    // 新しく契約IDを作成
    if (typeof this.props.callbacks.stepChange === 'function') {
      let info = this.state.info
      info.mode = def.MODE.CREATE_TENANT
      this.props.callbacks.stepChange(info, def.STEPS.LOGIN)
    }
  }

  onConnectTenantClick() {
    // 既存の契約IDを利用
    if (typeof this.props.callbacks.stepChange === 'function') {
      let info = this.state.info
      info.mode = def.MODE.CONNECT_TENANT
      this.props.callbacks.stepChange(info, def.STEPS.LOGIN)
    }
  }

  render() {
    const styles = {
      button: { margin: '25px' },
      buttonStyle: { height: '6rem', width: '200px' },
      buttonLabel: { top: '2rem', fontWeight: 'bold' },
      labelArea: { marginTop: '25px' },
      labelLarger: { margin: '0px', fontSize: 'larger', fontWeight: 'bold' },
      labelMedium: { margin: '0px', fontSize: 'medium' },
      labelSmall: { margin: '0px', fontSize: 'small' },
      label: { margin: '0px' },
      descriptionArea: { margin: '25px' },
      paper: { padding: '10px', width: '600px' },
      linkArea: { marginTop: '10px' },
      lineBreak: { whiteSpace: 'pre-wrap' }
    }
    return (
      <div className='AppContent'>
        <div style={{ width: '900px', textAlign: 'left', marginLeft: 'auto', marginRight: 'auto' }}>
          <div className='GroupPane' style={GridUtils.GridColumns('250px 1fr')}>
            <h2 style={GridUtils.GridPosStyleWithColspan(1, 1, 2)}>はじめに</h2>
            <div style={GridUtils.GridPosStyleWithColspan(2, 1, 2)}>
              <div style={styles.descriptionArea}>
                <p style={{ ...styles.labelMedium, ...styles.lineBreak }}>
                  {'この度は弊社製品「スマート大臣」のご利用をお申し込みいただきありがとうございます。\n下記のリンクより「初回登録・管理サイトマニュアル」をダウンロードいただき、文書中の指示に従って本サービスのご利用に必要な情報の登録を行ってください。'}
                </p>
                <div style={styles.linkArea}>
                  <a href='https://www.ohken.co.jp/smart/docs/smart_manual.pdf'
                    target='_blank'
                    rel="noopener noreferrer">
                    {'初回登録・管理サイトマニュアル'}
                  </a>
                </div>
              </div>
            </div>
            <h2 style={GridUtils.GridPosStyleWithColspan(3, 1, 2)}>初回登録方法の選択</h2>
            <div style={GridUtils.GridPosStyleWithColspan(4, 1, 1)}>
              <mui.RaisedButton
                style={styles.button}
                buttonStyle={styles.buttonStyle}
                labelStyle={styles.buttonLabel}
                overlayStyle={styles.buttonStyle}
                primary={true} label={'新しく契約IDを作成する'}
                onClick={() => this.onCreateTenantClick()} />
            </div>
            <div style={GridUtils.GridPosStyleWithColspan(4, 2, 1)}>
              <div style={styles.labelArea} />
              <p style={styles.labelLarger}>{'初めてサービスを利用する場合はこちらを選択してください。'}</p>
              <p style={styles.labelSmall}>{'（現在ご利用中のサービスとは会社・社員データを別々に管理する場合はこちらを選択してください。）'}</p>
            </div>
            <div style={GridUtils.GridPosStyleWithColspan(5, 1, 1)}>
              <mui.RaisedButton
                style={styles.button}
                buttonStyle={styles.buttonStyle}
                labelStyle={styles.buttonLabel}
                overlayStyle={styles.buttonStyle}
                secondary={true} label={'既存の契約IDを利用する'}
                onClick={() => this.onConnectTenantClick()} />
            </div>
            <div style={GridUtils.GridPosStyleWithColspan(5, 2, 1)}>
              <div style={styles.labelArea} />
              <p style={styles.labelLarger}>{'現在ご利用中のサービスと同じ会社・社員データを利用する場合は'}</p>
              <p style={styles.labelLarger}>{'こちらを選択してください。'}</p>
              <p style={styles.labelSmall}>{'（複数のサービスを利用する場合、通常はこちらを選択してください。）'}</p>
            </div>
            <div style={GridUtils.GridPosStyleWithColspan(6, 1, 2)}>
              <div style={styles.descriptionArea}>
                <p style={{ ...styles.labelLarger, color: 'red' }}>{'※初回登録を完了すると、登録方法を後から変更することはできません。'}</p>
                <div className='FlexBottom'>
                  <p style={styles.labelSmall}>{'どちらを選択していいか判らない場合は、お手数ですが'}</p>
                  <a href='https://www.ohken.co.jp/inquiry/index.html'
                    target='_blank'
                    rel="noopener noreferrer">
                    {'弊社サポートセンター'}
                  </a>
                  <p style={styles.labelSmall}>{'へお問い合わせください。'}</p>
                </div>
                {/* <mui.Paper style={styles.paper}>
                  <p style={styles.label}>{'フリーダイヤル：0120-999-070'}</p>
                  <p style={styles.labelSmall}>{'受付：9～12時／13～17時 （土日祝および弊社休業日を除く）'}</p>
                </mui.Paper> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ModeSelect.propTypes = {
  info: PropTypes.object.isRequired,
  callbacks: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/pages/modeSelect.js